import { programTypes } from '../../types'
import { initialProgramState } from '../initial-state'
import { ReduxAction, reduxTypes } from '../types'

const programReducer = (
  previousState = initialProgramState, action: ReduxAction<programTypes.Program>,
) => {
  if (action.type === reduxTypes.PROGRAM_UPDATE) {
    return action.payload
  }
  return previousState
}

export default programReducer
